import { rhumbDistanceNm, rhumbBearingDeg, type LatLon } from '@boatnav/core';

export interface MeasureTotals {
  /** Sum of all legs, nm. 0 with fewer than 2 points. */
  totalNm: number;
  /** Distance of the most recently added leg, nm. Null with fewer than 2 points. */
  lastLegNm: number | null;
  /** Rhumb bearing of the most recently added leg, degrees [0, 360). Null with fewer than 2 points. */
  lastLegBrg: number | null;
}

/** Pure so the readout chip's math is unit-testable against a fixture (spec 14A acceptance). */
export function computeMeasureTotals(points: LatLon[]): MeasureTotals {
  if (points.length < 2) return { totalNm: 0, lastLegNm: null, lastLegBrg: null };
  let total = 0;
  for (let i = 1; i < points.length; i++) {
    total += rhumbDistanceNm(points[i - 1]!, points[i]!);
  }
  const a = points[points.length - 2]!;
  const b = points[points.length - 1]!;
  return { totalNm: total, lastLegNm: rhumbDistanceNm(a, b), lastLegBrg: rhumbBearingDeg(a, b) };
}
